import { Notification } from '../../Notifications.types';

export function excludeNotifications(notification: Notification) {
  const isTaskNotification = notification.type?.includes('TASK');
  const resourceLocationIsTask = notification.resourceLocation?.includes('api/task');
  return !isTaskNotification && !resourceLocationIsTask;
}
